"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var Option_component_exports = {};
__export(Option_component_exports, {
  Option: () => Option,
  default: () => Option_component_default
});
module.exports = __toCommonJS(Option_component_exports);
var import_react = __toESM(require("react"));
var import_comboboxHelperUtils = require("../../../utils/comboboxHelperUtils");
var import_ComboboxOption = require("../../atoms/ComboboxOption/ComboboxOption.component");
var import_InputCombobox = require("./InputCombobox.component");
function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function(n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t)
        ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}
function _toConsumableArray(r) {
  return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread();
}
function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(r, a) {
  if (r) {
    if ("string" == typeof r)
      return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
  }
}
function _iterableToArray(r) {
  if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"])
    return Array.from(r);
}
function _arrayWithoutHoles(r) {
  if (Array.isArray(r))
    return _arrayLikeToArray(r);
}
function _arrayLikeToArray(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++)
    n[e] = r[e];
  return n;
}
var Option = function Option2(props) {
  var _UseInputComboboxCtx = (0, import_InputCombobox.UseInputComboboxCtx)(), setOpen = _UseInputComboboxCtx.setOpen, setSelected = _UseInputComboboxCtx.setSelected, selected = _UseInputComboboxCtx.selected, itemPosition = _UseInputComboboxCtx.itemPosition, multiSelect = _UseInputComboboxCtx.multiSelect, maxVisibleChars = _UseInputComboboxCtx.maxVisibleChars, setSelection = _UseInputComboboxCtx.setSelection;
  var isSelected = selected && selected.includes(props.value);
  var handleSelection = function handleSelection2() {
    if (props.disabled) {
      return false;
    }
    if (multiSelect) {
      if (isSelected && selected.length > 0) {
        setSelected((0, import_comboboxHelperUtils.filterComboboxItems)(selected, props.value));
      } else {
        setSelected([].concat(_toConsumableArray(selected), [props.value]));
      }
    } else {
      setSelected([props.value]);
      setOpen(false);
    }
    setSelection(true);
    return false;
  };
  return /* @__PURE__ */ import_react.default.createElement(import_ComboboxOption.ComboboxOption, _extends({
    id: props.id,
    isSelected,
    itemPosition,
    multiSelect,
    navId: props.navId,
    handleSelection
  }, props), (0, import_comboboxHelperUtils.getOptionValue)(props.children, maxVisibleChars));
};
var Option_component_default = Option;
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  Option
});
//# sourceMappingURL=Option.component.js.map